export const getWarehouseLevelDisplayName = ({ layout, levelId, fallbackName } = {}) => {
  const normalizedLevelId = String(levelId || "").trim();
  const level = (Array.isArray(layout?.levels) ? layout.levels : []).find(
    (entry) => String(entry?.id || "") === normalizedLevelId
  );
  return String(level?.name || fallbackName || normalizedLevelId).trim();
};

export const getStorageLocationDisplay = ({
  binLabel,
  warehouseCell,
  binSubLocation,
  binShelfLevel,
  boxRef,
  delimiter = " · ",
} = {}) => [
  String(binLabel || warehouseCell || "").trim(),
  String(binSubLocation || "").trim(),
  String(binShelfLevel || "").trim(),
  String(boxRef || "").trim(),
].filter(Boolean).join(delimiter);

export const getWarehouseLevelTooltip = ({ layout, levelId, fallbackName } = {}) => {
  const displayName = getWarehouseLevelDisplayName({ layout, levelId, fallbackName });
  return displayName ? `Warehouse level: ${displayName}` : "";
};

export const buildReceiptStoragePresentation = (receipt = {}, layout = null) => ({
  visibleText: getStorageLocationDisplay(receipt),
  levelName: getWarehouseLevelDisplayName({ layout, levelId: receipt?.warehouseLevel }),
  tooltip: getWarehouseLevelTooltip({ layout, levelId: receipt?.warehouseLevel }),
});
